export const convertObjectToString = (classes) => {
  return Object
    .keys(classes)
    .filter(key => !!classes[key])
    .reduce(
      (classString, item) => (classString
        ? `${classString}${item ? ` ${item}` : ''}`
        : `${item}`),
      '',
    );
}

export const classnames = (...classes) => {
  if (classes[0] && typeof classes[0] === 'string') {
    return classes.join(' ');
  }
  return convertObjectToString(classes[0]);
}
